var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarimg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.484,
    height: 29.484,
    viewBox: "0 0 29.484 29.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "global-svgrepo-com",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14582",
    "data-name": "Path 14582",
    d: "M9.825,23.077c-.044,0-.1.029-.147.029a14.751,14.751,0,0,1-6.619-6.619c0-.044.029-.1.029-.147a47.015,47.015,0,0,0,5.5,1.238A49.456,49.456,0,0,0,9.825,23.077Z",
    transform: "translate(0.502 6.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14583",
    "data-name": "Path 14583",
    d: "M23.144,16.5a14.88,14.88,0,0,1-6.855,6.737,45.056,45.056,0,0,0,1.342-5.661,46.114,46.114,0,0,0,5.484-1.238C23.1,16.4,23.144,16.458,23.144,16.5Z",
    transform: "translate(6.776 6.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14584",
    "data-name": "Path 14584",
    d: "M23.262,9.953a46.649,46.649,0,0,0-5.631-1.342A41.152,41.152,0,0,0,16.289,2.98,14.818,14.818,0,0,1,23.262,9.953Z",
    transform: "translate(6.776 0.465)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14585",
    "data-name": "Path 14585",
    d: "M9.865,3.1A46.067,46.067,0,0,0,8.641,8.587,42.56,42.56,0,0,0,2.98,9.914,14.88,14.88,0,0,1,9.718,3.059C9.762,3.059,9.821,3.1,9.865,3.1Z",
    transform: "translate(0.465 0.502)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14586",
    "data-name": "Path 14586",
    d: "M18.8,8.767a46.184,46.184,0,0,0-10.29,0,41.828,41.828,0,0,1,1.5-5.985,2.41,2.41,0,0,0,.029-.324A15.34,15.34,0,0,1,13.657,2a15.216,15.216,0,0,1,3.6.457,2.447,2.447,0,0,0,.044.324A42.327,42.327,0,0,1,18.8,8.767Z",
    transform: "translate(3.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14587",
    "data-name": "Path 14587",
    d: "M8.767,18.8a41.341,41.341,0,0,1-5.985-1.5,2.411,2.411,0,0,0-.324-.029A15.34,15.34,0,0,1,2,13.657a15.216,15.216,0,0,1,.457-3.6,2.448,2.448,0,0,0,.324-.044,43.887,43.887,0,0,1,5.985-1.5A48.02,48.02,0,0,0,8.767,18.8Z",
    transform: "translate(0 3.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14588",
    "data-name": "Path 14588",
    d: "M24.177,13.657a15.34,15.34,0,0,1-.457,3.612,2.411,2.411,0,0,0-.324.029,44.437,44.437,0,0,1-5.985,1.5,46.184,46.184,0,0,0,0-10.29,41.828,41.828,0,0,1,5.985,1.5,1.228,1.228,0,0,0,.324.044A15.315,15.315,0,0,1,24.177,13.657Z",
    transform: "translate(7.308 3.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14589",
    "data-name": "Path 14589",
    d: "M18.8,17.41A41.341,41.341,0,0,1,17.3,23.4a2.447,2.447,0,0,0-.044.324,15.216,15.216,0,0,1-3.6.457,15.34,15.34,0,0,1-3.612-.457,2.41,2.41,0,0,0-.029-.324,43.887,43.887,0,0,1-1.5-5.985,46.128,46.128,0,0,0,5.145.324A45.907,45.907,0,0,0,18.8,17.41Z",
    transform: "translate(3.088 7.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14590",
    "data-name": "Path 14590",
    d: "M19.445,19.445a44.278,44.278,0,0,1-11.1,0,44.283,44.283,0,0,1,0-11.1,44.283,44.283,0,0,1,11.1,0A44.278,44.278,0,0,1,19.445,19.445Z",
    transform: "translate(2.845 2.845)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarimg5);
export default __webpack_public_path__ + "static/media/sidebarimg5.952d557e88b76c220d2145aa330fc003.svg";
export { ForwardRef as ReactComponent };